import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { PaymentMethodSettingsService } from './payment-method-settings.service';
import { helperService } from 'src/app/utils/helper';
import { ProjectsGridService } from '../projects-grid/projects-grid.service';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'payment-method-settings',
    templateUrl: './payment-method-settings.component.html',
    styleUrls: ['./payment-method-settings.component.scss'],
    standalone: false
})
export class PaymentMethodSettingsComponent implements OnInit {
  paymentMethods: any[] = [];
  cols: any[] = [];
  paymentDialog = false;
  viewOnly = false;
  newPayment = false;
  title = '';
  loading = true;
  totalRecords = 0;
  first = 1;
  submitted = false;
  btnLoading = false;
  lastTableLazyLoadEvent: any = null;

  paymentForm: UntypedFormGroup;
  defaultPaymentForm: any = {};

  typeList = [
    // { label: 'Blue River PEX', value: 'Blue River PEX' },
    // { label: 'Personal PEX', value: 'Personal PEX' },
    // { label: 'Client CC', value: 'Client CC' },
    // { label: 'PNC Credit Card', value: 'PNC Credit Card' },
    // { label: 'Del DCIS', value: 'Del DCIS' },
    // { label: 'Check', value: 'Check' },
    // { label: 'Stamps.com', value: 'Stamps.com' },
    // { label: 'FedEX', value: 'FedEX' },
    // { label: 'Escrow', value: 'Escrow' },
    { label: 'Credit Card', value: 'Credit Card' },
    { label: 'Check', value: 'Check' },
    { label: 'Bill', value: 'Bill' },

  ];

  statusList = [
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Inactive' }
  ];

  private paymentMethodsSubscription: any = null;
  userList: any[] = [];

  constructor(
    private paymentService: PaymentMethodSettingsService,
    private readonly messageService: MessageService,
    private cdr: ChangeDetectorRef,
    private helperService: helperService,
    private projectService: ProjectsGridService
  ) {
    this.paymentForm = new UntypedFormGroup({
      id: new UntypedFormControl(''),
      accountName: new UntypedFormControl('', [Validators.required]),
      glCode: new UntypedFormControl('', [Validators.required]),
      status: new UntypedFormControl(''),
      type: new UntypedFormControl('', [Validators.required]),
      createdBy: new UntypedFormControl(''),
      createdOn: new UntypedFormControl(''),
      users: new UntypedFormControl([], [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.initTableCols();
    this.defaultPaymentForm = this.paymentForm.value;
    this.loading = true;
    // Fetch users and payment methods in parallel
    forkJoin({
      users: this.projectService.getLPCUsersList({}),
      payments: this.paymentService.getPaymentMethods(1, 10, this.helperService.generateEventPayload({ first: 1, rows: 10 }))
    }).subscribe(
      ({ users, payments }) => {
        this.userList = users?.data || [];
        this.paymentMethods = payments.data;
        this.totalRecords = payments.customValues.totalNumberOfRecords;
        this.loading = false;
      }, err => {
        this.userList = [];
        this.paymentMethods = [];
        this.totalRecords = 0;
        this.loading = false;
      }
    );
  }

  private initTableCols() {
    this.cols = [
      { field: 'accountName', header: 'Payment Name' },
      { field: 'type', header: 'Payment Type' },
      { field: 'glCode', header: 'GL Code' },
      { field: 'status', header: 'Status' },
      { field: 'createdBy', header: 'Created By' },
    ];
  }
  addPaymentMethod(): void {
    this.paymentDialog = true;
    this.viewOnly = false;
    this.newPayment = true;
    this.title = "Add Payment Method";
    this.paymentForm.reset(this.defaultPaymentForm);
    this.paymentForm.enable();
    // Set default status to Active for new payment method
    this.paymentForm.get('status')?.setValue('Active');
  }

  loadPaymentMethods(event: any) {
    // Prevent grid load on first page load if users are not loaded yet
    if (this.loading) return;
    // Unsubscribe previous subscription if exists
    if (this.paymentMethodsSubscription) {
      this.paymentMethodsSubscription.unsubscribe();
    }
    event = event ? event : this.lastTableLazyLoadEvent || { first: 1, rows: 10 };
    this.lastTableLazyLoadEvent = event;
    this.loading = true;
    event.first = event.first || 1;
    event.rows = event.rows || 10;
    // Build payload for filters and sorting, similar to catalogue
    const payload = this.helperService.generateEventPayload(event);
    this.paymentMethodsSubscription = this.paymentService.getPaymentMethods(Math.floor(event.first / event.rows + 1), event.rows, payload)
      .subscribe(res => {
        this.paymentMethods = res.data;
        this.loading = false;
        this.totalRecords = res.customValues.totalNumberOfRecords;
      });
  }


  addPayment(): void {
    this.paymentDialog = true;
    this.viewOnly = false;
    this.newPayment = true;
    this.title = "Add Payment Method";
    this.paymentForm.reset(this.defaultPaymentForm);
    this.paymentForm.enable();
  }

  closeDialog(): void {
    this.paymentDialog = false;
    this.submitted = false;
    this.paymentForm.reset(this.defaultPaymentForm);
    this.paymentForm.enable();
    this.loadPaymentMethods(this.lastTableLazyLoadEvent);
    this.cdr.detectChanges();
  }

  editPayment(payment: any): void {
    payment.users=payment.users.map((user: any) => {
      return user.id;
    });
    this.paymentForm.patchValue(payment);
    this.paymentDialog = true;
    this.viewOnly = false;
    this.newPayment = false;
    this.title = "Edit Payment Method";
  }

  viewPayment(payment: any): void {
     payment.users=payment.users.map((user: any) => {
      return user.id;
    });
    this.paymentForm.patchValue(payment);
    this.paymentForm.disable();
    this.paymentDialog = true;
    this.viewOnly = true;
    this.newPayment = false;
    this.title = "View Payment Method";
  }

  savePayment() {
    if (this.btnLoading) return;
    this.submitted = true;
    this.messageService.clear();
    if (this.paymentForm.valid) {
      this.btnLoading = true;
      this.paymentForm.disable();
      const payload = this.paymentForm.getRawValue();
      // Ensure users field is passed as array of IDs
      payload.userIds = (payload.users || []).map((u: any) => typeof u === 'object' ? u.id : u);
      // If adding new payment method, id should be undefined/null
      const id = this.newPayment ? undefined : payload.id;
      if(this.newPayment){
        delete payload.id; // Remove id for new payment method
      }
      this.paymentService.savePaymentMethod(payload, id).subscribe(
        res => {
          this.btnLoading = false;
          if (res.message) {
            this.viewOnly = true;
            this.messageService.add({ severity: 'success', detail: this.newPayment ? 'Payment method added successfully' : 'Payment method updated successfully' });
            this.paymentDialog = false;
            this.loadPaymentMethods(this.lastTableLazyLoadEvent);
          } else {
            this.messageService.add({ severity: 'error', detail: res.message });
          }
        },
        error => {
          this.btnLoading = false;
          this.messageService.add({ severity: 'error', detail: error.message });
        }
      );
    } else {
      const invalidControls = Object.keys(this.paymentForm.controls)
        .filter(key => this.paymentForm.controls[key].invalid)
        .map(key => key);
      this.messageService.add({
        severity: 'error',
        detail: `Please fill all mandatory fields correctly. Invalid: ${invalidControls.join(', ')}`
      });
    }
  }

  setPaymentStatus(payment: any) {
    if (!payment || !payment.id) return;
    let payload = { ...payment };
    payload.status = payment.status === 'Active' ? 'Inactive' : 'Active';
    this.btnLoading = true;
    this.paymentService.savePaymentMethod(payload, payment.id).subscribe(
      res => {
        this.btnLoading = false;
        this.loadPaymentMethods(this.lastTableLazyLoadEvent);
        this.messageService.add({ severity: 'success', detail: `Payment method ${payload.status === 'Active' ? 'activated' : 'inactivated'} successfully.` });
      },
      error => {
        this.btnLoading = false;
        this.messageService.add({ severity: 'error', detail: error.message });
      }
    );
  }

  getPaymentStatusActionTooltip(payment: any): string {
    return payment?.status === 'Active' ? 'Inactivate payment method' : 'Activate payment method';
  }

  // Form control getters for template usage
  get accountName() { return this.paymentForm.get('accountName'); }
  get glCode() { return this.paymentForm.get('glCode'); }
  get status() { return this.paymentForm.get('status'); }
  get type() { return this.paymentForm.get('type'); }

  private selectedUserLabelsCache: { selected: any; options: any; labels: string[] } | null = null;

  getSelectedUserLabels(): string[] {
    const selected = this.paymentForm.get('users')?.value;
    const cache = this.selectedUserLabelsCache;
    if (cache && cache.selected === selected && cache.options === this.userList) {
      return cache.labels;
    }
    const emailById = new Map<any, any>(
      (this.userList || []).map((user: any) => [user.id, user.mainEmail])
    );
    const labels = Array.from(new Set(selected || []))
      .map((id: any) => emailById.get(id) ?? `Unknown user #${id}`);
    this.selectedUserLabelsCache = { selected, options: this.userList, labels };
    return labels;
  }
}
